export default __webpack_public_path__ + "static/media/imageMascot.257c02c0.png";